var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M19 30C19.56 30 20.04 29.8 20.42 29.42C20.81 29.04 21 28.56 21 28C21 27.43 20.81 26.95 20.42 26.57C20.04 26.19 19.56 26 19 26C18.43 26 17.96 26.19 17.57 26.57C17.19 26.95 17 27.43 17 28C17 28.56 17.19 29.04 17.57 29.42C17.96 29.8 18.43 30 19 30ZM17 22L21 22L21 10L17 10L17 22ZM19 40C16.23 40 13.63 39.47 11.2 38.42C8.76 37.37 6.65 35.95 4.85 34.15C3.05 32.34 1.62 30.23 0.57 27.79C-0.48 25.36 -1 22.76 -1 20C-1 17.23 -0.48 14.63 0.57 12.2C1.62 9.76 3.05 7.65 4.85 5.84C6.65 4.04 8.76 2.62 11.2 1.57C13.63 0.52 16.23 0 19 0C21.76 0 24.36 0.52 26.8 1.57C29.23 2.62 31.35 4.04 33.15 5.84C34.95 7.65 36.37 9.76 37.42 12.2C38.47 14.63 39 17.23 39 20C39 22.76 38.47 25.36 37.42 27.79C36.37 30.23 34.95 32.34 33.15 34.15C31.35 35.95 29.23 37.37 26.8 38.42C24.36 39.47 21.76 40 19 40ZM19 36C23.46 36 27.25 34.45 30.35 31.34C33.45 28.25 35 24.46 35 20C35 15.53 33.45 11.75 30.35 8.65C27.25 5.54 23.46 4 19 4C14.53 4 10.75 5.54 7.65 8.65C4.55 11.75 3 15.53 3 20C3 24.46 4.55 28.25 7.65 31.34C10.75 34.45 14.53 36 19 36Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.88e127c14379eb0266f01fddb25b9ccd.svg";
export { ForwardRef as ReactComponent };